<template>
	<svg
		width="144"
		height="126"
		viewBox="0 0 144 126"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M72 126C111.765 126 144 121.075 144 115C144 108.925 111.765 104 72 104C32.2355 104 0 108.925 0 115C0 121.075 32.2355 126 72 126Z"
			fill="#DCDBE1"
		/>
		<path
			d="M110.667 14.5H105.833V4.83337H96.1665V14.5H47.8332V4.83337H38.1665V14.5H33.3332C30.7717 14.5075 28.3173 15.5284 26.5061 17.3396C24.6948 19.1508 23.674 21.6052 23.6665 24.1667V101.5C23.674 104.061 24.6948 106.516 26.5061 108.327C28.3173 110.138 30.7717 111.159 33.3332 111.167H110.667C113.228 111.159 115.682 110.138 117.494 108.327C119.305 106.516 120.326 104.061 120.333 101.5V24.1667C120.326 21.6052 119.305 19.1508 117.494 17.3396C115.682 15.5284 113.228 14.5075 110.667 14.5ZM110.667 101.5H33.3332V38.6667H110.667V101.5Z"
			fill="#807B91"
		/>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-calendar-with-shadow',
	components: {},
	computed: {},
	props: {}
};
</script>

<style scoped lang="scss"></style>

<docs>
	IconCalendarWithShaddow

	```js
	<b-icon-calendar-with-shadow />
	```
</docs>
